import type { App } from 'vue';

import { vPermission } from './permission';

export { vPermission };

/**
 * core-fe가 제공하는 전역 디렉티브를 한꺼번에 등록한다.
 */
export function registerDirectives(app: App): void {
  app.directive('permission', vPermission);
}
